module.exports = __webpack_public_path__ + "static/media/slider4.3d217d17.jpg";